import Vue from 'vue/dist/vue.esm.js'

Vue.component('reports-project-partner-report-period-row',
  template: JST['reports/project_partner_report_period_row']()
  props: ['projectPartnerReportPeriod', 'multiplePeriodsSelected']

  mounted: ->
    $('[data-toggle="tooltip"]').tooltip()
  data: ->
    pprp: @projectPartnerReportPeriod

  watch:
    'pprp.visible_for_client': ->
      @persistUpdates() unless @multiplePeriodsSelected
    'pprp.state': ->
      @persistUpdates() unless @multiplePeriodsSelected
  methods:
    persistUpdates: ->
      $.ajax
        dataType: 'JSON',
        url: "/admin/project_partner_report_periods/#{@pprp.id}"
        method: 'PUT'
        data: _.pick(@pprp, ['visible_for_client','state'])
        success: =>
          Helper.flashRow($(@$el), '#bfdf9f')
    setStateToDraft: ->
      @pprp.state = 'draft'
    setStateToClosed: ->
      @pprp.state = 'closed'
)
